<div class="my-2">
  <form [formGroup]="formData">
    <label *ngIf="group.name === 'personal details'">{{
      question.label
    }}</label>
    <div class="input-group">
      <input
        ngbDatepicker
        #date="ngbDatepicker"
        [startDate]="startDate"
        [minDate]="{ year: 1800, month: 1, day: 1 }"
        [maxDate]="{ year: 2038, month: 1, day: 19 }"
        formControlName="field"
        autoClose="true"
        placeholder="mm/dd/yyyy"
        (click)="date.toggle()"
        class="form-control"
        [ngClass]="{ 'is-invalid': form.field.errors }" />
      <span class="input-group-text"><i class="bx bx-calendar-event"></i></span>
    </div>
    <div
      class="mt-2"
      *ngIf="form.field.errors"
      style="font-size: 80%; color: rgb(244 106 106)">
      <span *ngIf="form.field.errors.required"
        >Please provide a valid response.</span
      >
    </div>
  </form>
</div>
